import { useRouter } from "next/router";
import { useEffect } from "react";

/**
 * Adds a `routeChangeStart` performance mark on every Next.js navigation.
 *
 * `useTimeSinceNavigation` measures from this mark. Call this hook once in the
 * application, for example in `_app.tsx`.
 */
export function useNavigationMarks() {
  const router = useRouter();

  // Add performance marks for navigation events
  useEffect(() => {
    const handleRouteChangeStart = () => {
      // Clear previous marks so that useTimeSinceNavigation measures from the
      // most recent navigation, not the first one in the session.
      window.performance.clearMarks("routeChangeStart");
      window.performance.mark("routeChangeStart");
    };

    // Mark each navigation start
    router.events.on("routeChangeStart", handleRouteChangeStart);

    return () => {
      router.events.off("routeChangeStart", handleRouteChangeStart);
    };
  }, []);
}
